import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMenuOpen: false,
  isLoading: false,
  activeSection: 'home',
  notifications: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    },
  },
});

export const {
  toggleMenu,
  setLoading,
  setActiveSection,
  addNotification,
  removeNotification,
} = uiSlice.actions;

export default uiSlice.reducer; 